function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
  
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
  	if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }


  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener); 
    
class IshiModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'ISHIMODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.classList.add("active");
    document.querySelector('.newsletter-popup-overlay')? document.querySelector('.newsletter-popup-overlay').classList.add("active") : '';
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.classList.remove("active");
    document.querySelector('.newsletter-popup-overlay')? document.querySelector('.newsletter-popup-overlay').classList.remove("active") : '';
    this.openedBy.setAttribute("aria-expanded","false");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    if(this.getAttribute("id") == "PopupModal-newsletter"){
      if($('.dono-show-check').prop("checked") == true) {
        setTheCookie("customer_posted", "true", 14);
      }
  	}
  }
}
customElements.define('ishimodal-dialog', IshiModalDialog);

class IshiModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('.ishi-popup-modal__button');
    if (!button) return;
        button.addEventListener('click', () => {
          const modal = document.querySelector(this.getAttribute('data-modal'));
          if (modal) modal.show(button);
    });
  }
}
customElements.define('ishimodal-opener', IshiModalOpener);

class QuickviewDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'QUICKVIEW-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.classList.add("active");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.classList.remove("active");
    this.querySelector(".qv-wrapper").classList.add("loading");
    this.openedBy.setAttribute("aria-expanded","false");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('quickview-dialog', QuickviewDialog);

class QuickviewOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('.product-popup-modal__button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('quickview-opener', QuickviewOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
     window.pauseAllMedia();
     if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);
    
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
     var rtlFlag = $("body").hasClass("lang-rtl") ? true : false;
    if ((rtlFlag = true)) {
    if (this.currentPage === 1) {
      this.prevButton.removeAttribute("disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }
  }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    try {
      if (window.loadColorMap) { window.loadColorMap().then(function(){ if (window.applySwatchColors) window.applySwatchColors(); }); }
      this.onVariantChange();
      if (window.applyVariantMediaFilter) {
        setTimeout(function(){ window.applyVariantMediaFilter(); }, 0);
      }
      if (window.applySwatchColors) {
        setTimeout(function(){ window.applySwatchColors(); }, 0);
      }
    } catch (e) {}
  }

  onVariantChange() {
    console.log('[variant-radios] onVariantChange fired');
    this.updateOptions();
    console.log('[variant-radios] options:', this.options);
    this.updateMasterId();
    console.log('[variant-radios] currentVariant:', this.currentVariant ? this.currentVariant.id : null);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      if (window.applyVariantMediaFilter) {
        setTimeout(function(){ window.applyVariantMediaFilter(); }, 0);
      }
      if (window.applySwatchColors) {
        setTimeout(function(){ window.applySwatchColors(); }, 0);
      }
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.doIshiTasks();
      // Dispatch custom event so template listener updates gallery/metafield images
      this.dispatchEvent(new CustomEvent('variant-radios:change', {
        detail: { id: this.currentVariant.id, variant: this.currentVariant },
        bubbles: true
      }));
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
//     const parent = newMedia.parentElement;
//     parent.prepend(newMedia);
//     window.setTimeout(() => { parent.scroll(0, 0) });
       document.getElementById('main-media-container').innerHTML = "";
       document.getElementById('main-media-container').prepend(newMedia.cloneNode(true));
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    /*
     * `product-form-${data-section}` is the Dawn convention: the product form is
     * expected to declare that id (see product_form_id in
     * sections/main-product.liquid and templates/product.mc.liquid).
     *
     * If a template forgot it, Shopify renders `product_form_<n>` instead and
     * this used to find nothing and return quietly - the hidden input kept the
     * variant from page load, so the cart received the WRONG variant and the
     * bulk pricing calculator priced the wrong one, with no error anywhere.
     * Fall back to the form the picker actually lives in.
     */
    let productForms = Array.from(
      document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`)
    );

    if (!productForms.length) {
      const owner = this.closest('form') || document.querySelector('form[action*="/cart/add"]');
      if (!owner) return;
      console.warn('[variant-radios] no #product-form-' + this.dataset.section +
        '; falling back to the enclosing form. Set an explicit form id in the template.');
      productForms = [owner];
    }

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }
  
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    // Update price directly without fetching section.
    // On the MC PDP the price display is owned by the bulk pricing calculator
    // (snippets/bulk-pricing-calculator.liquid), which mirrors the tier unit
    // price onto .product-price. Writing here as well would make the two fight
    // over the same element - the calculator emits 'bulk:price-base-change' and
    // re-reads the variant price itself.
    const priceElement = document.querySelector('.product-price');
    const calculatorOwnsPrice = !!document.querySelector('[data-bulk-pricing]');

    if (priceElement && this.currentVariant && !calculatorOwnsPrice) {
      priceElement.textContent = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'HKD'
      }).format(this.currentVariant.price / 100);
    }

    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  doIshiTasks() {
	var variant = this.currentVariant;
    var skuTarget = document.querySelector(".variant-sku");
	if (typeof(skuTarget) != 'undefined' && skuTarget != null) {
		document.querySelector(".variant-sku").innerHTML = variant.sku;
	}
    if (document.getElementsByClassName("ishi-progress-content").length) {
	  var stock = 0;
      var variantSpan =  document.getElementById("variant-" + variant.id);
      if (typeof(variantSpan) != 'undefined' && variantSpan != null)
      {
      	stock = parseInt(variantSpan.getAttribute("data-stock"));
      }
      var maxqty = parseInt(document.getElementsByClassName("ishi-progress-content")[0].getAttribute("data-quantity"));
	  document.getElementById("variant-stock").innerHTML = stock;
      if(stock > 0 && stock <= maxqty) {
        document.getElementsByClassName("ishi-progress-content")[0].classList.remove("hidden");
		var progressSpan =  document.getElementById("ishi-progress-bar").getElementsByTagName("span")[0];
		switch(stock){case 9:progressSpan.style.width = "65%";break;case 8:progressSpan.style.width = "60%";break;case 7:progressSpan.style.width = "55%";break;case 6:progressSpan.style.width = "50%";break;case 5:progressSpan.style.width = "45%";break;case 4:progressSpan.style.width = "30%";break;case 3:progressSpan.style.width = "20%";break;case 2:progressSpan.style.width = "10%";break;case 1:progressSpan.style.width = "5%";break;default:progressSpan.style.width = "90%";}
     } else {
         document.getElementsByClassName("ishi-progress-content")[0].classList.add("hidden");
      }
	} 

  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      // Only look for radio/checkbox inputs (not hidden inputs)
      const radioInputs = Array.from(fieldset.querySelectorAll('input[type="radio"], input[type="checkbox"]'));
      if (radioInputs.length === 0) {
        // No radio inputs — fall back to hidden input (e.g., style option rendered by customizer)
        const hiddenInput = fieldset.querySelector('input[type="hidden"]');
        return hiddenInput ? hiddenInput.value : '';
      }
      const checked = radioInputs.find(function(radio) { return radio.checked; });
      return checked ? checked.value : '';
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// Helpers for console debugging on main product page
window.getCurrentVariant = function() {
  const el = document.querySelector('variant-selects, variant-radios');
  if (!el) return null;
  if (el.currentVariant) return el.currentVariant;
  const data = el.getVariantData ? el.getVariantData() : null;
  if (!data || !data.length) return null;
  const params = new URLSearchParams(window.location.search);
  const vid = params.get('variant');
  if (vid) {
    for (var i = 0; i < data.length; i++) {
      if (String(data[i].id) === String(vid)) return data[i];
    }
  }
  return data[0];
};

window.applySwatchColors = function() {
  // Use Shopify product metafields for color mapping
  var map = window.COLOR_MAP || { 
    sandstone: '#D8C9B5', 
    evergreen: '#2C5E37', 
    pink: '#FFC0CB', 
    white: '#FFFFFF', 
    black: '#000000', 
    navy: '#000080', 
    'slate green': '#708090', 
    kraft: '#D2B48C', 
    'dark grey': '#555555', 
    'dark_gray': '#555555', 
    grey: '#808080', 
    gray: '#808080', 
    olive: '#556B2F', 
    red: '#FF0000' 
  };
  
  // Try to get color metafields from current product
  var variantPicker = document.querySelector('variant-radios');
  if (variantPicker && variantPicker.dataset.url && window.productColorMetafields) {
    // Extract product handle from URL
    var productHandle = variantPicker.dataset.url.split('/').pop();
    if (productHandle && window.productColorMetafields[productHandle]) {
      var productMeta = window.productColorMetafields[productHandle];
      // Merge metafield colors with default map
      Object.assign(map, productMeta);
    }
  }
  
  function resolveColor(name){ 
    var key = String(name||'').toLowerCase().trim(); 
    var v = map[key]; 
    if (v) return v; 
    var test = document.createElement('div'); 
    test.style.backgroundColor = name; 
    return test.style.backgroundColor ? name : null; 
  }
  
  function hexToRgb(h){ 
    var s=h.replace('#',''); 
    if (s.length===3) s=s.split('').map(function(x){return x+x}).join(''); 
    var n=parseInt(s,16); 
    return { r:(n>>16)&255, g:(n>>8)&255, b:n&255 }; 
  }
  
  function isLight(color){ 
    if (!color) return false; 
    var rgb; 
    if (color[0]==='#'){ 
      rgb=hexToRgb(color); 
    } else { 
      var d=document.createElement('div'); 
      d.style.backgroundColor=color; 
      document.body.appendChild(d); 
      var cs=getComputedStyle(d).backgroundColor; 
      document.body.removeChild(d); 
      var m=cs.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/); 
      rgb=m?{r:+m[1],g:+m[2],b:+m[3]}:{r:0,g:0,b:0}; 
    } 
    var luminance=(0.2126*rgb.r+0.7152*rgb.g+0.0722*rgb.b)/255; 
    return luminance>0.6; 
  }
  
  var labels = document.querySelectorAll('fieldset.product-form__input.color label[data-color]');
  labels.forEach(function(label){
    var name = label.getAttribute('data-color') || label.textContent;
    var color = resolveColor(name);
    if (!color) return;

    // For guided picker: keep square swatches
    var inVariantRadios = !!(label.closest && label.closest('variant-radios'));
    label.style.setProperty('--swatch-color', color);
    label.style.backgroundColor = color;
    label.style.border = '1px solid #e5e5e5';
    label.style.display = 'inline-block';

    if (inVariantRadios) {
      label.style.width = '24px';
      label.style.height = '24px';
      label.style.borderRadius = '4px';
    } else {
      // Other places can keep existing look
      label.style.width = '32px';
      label.style.height = '32px';
      label.style.borderRadius = '50%';
    }

    var tip = label.querySelector('.tool-tip');
    if (tip) {
      tip.style.background = '#ffffff';
      tip.style.color = '#232323';
      tip.style.border = '1px solid #e5e5e5';
    }
  });

  // product.mc.liquid swatches
  var swatchInners = document.querySelectorAll('.product-form__swatch-inner[data-swatch-value]');
  swatchInners.forEach(function(el){
    var name = el.getAttribute('data-swatch-value') || '';
    var color = resolveColor(name);
    if (!color) return;
    el.style.setProperty('--swatch-color', color);
  });

  /*
   * PATTERN colours - the "Solid" vs "not Solid" split.
   *
   * Liquid already decided this per option value (see window.pdpColorSwatches)
   * by comparing the metaobject's pattern_taxonomy_reference against Shopify's
   * "Solid" value, gid://shopify/TaxonomyValue/2874. Anything that is NOT Solid
   * is a design rather than a colour, so the button shows the variant image
   * instead of a hex square.
   *
   * These labels deliberately carry no [data-color], so the hex loop above
   * skips them; the class is `color-image-button`, not `color-swatch`, so the
   * `.color-swatch[style]` !important sizing in product-customizer.css cannot
   * force them into a 24px circle either.
   */
  var imageMap = window.pdpColorVariantImages || {};
  var swatchPlan = window.pdpColorSwatches || {};
  document.querySelectorAll('fieldset.product-form__input.color label.color-image-button').forEach(function(label){
    var key = String(label.getAttribute('data-colour') || '').toLowerCase().trim();
    var img = imageMap[key] || '';
    if (!img) {
      // No variant image for this design - fall back to the metaobject hex so
      // the option is still visible and clickable rather than an empty box.
      var plan = swatchPlan[key];
      if (plan && plan.hex) label.style.backgroundColor = plan.hex;
      return;
    }
    label.style.backgroundImage = "url('" + img + "')";
    label.style.backgroundSize = 'cover';
    label.style.backgroundPosition = 'center';
    label.style.backgroundRepeat = 'no-repeat';
  });
};

window.loadColorMap = function() {
  if (window.COLOR_MAP || !window.COLOR_MAP_URL) return Promise.resolve(window.COLOR_MAP);
  return fetch(window.COLOR_MAP_URL, { credentials: 'same-origin' })
    .then(function(r){ return r.ok ? r.json() : {}; })
    .then(function(json){ window.COLOR_MAP = json || {}; return window.COLOR_MAP; })
    .catch(function(){ return {}; });
};

document.addEventListener('DOMContentLoaded', function(){
  if (window.loadColorMap) {
    window.loadColorMap().then(function(){ if (window.applySwatchColors) window.applySwatchColors(); });
  } else if (window.applySwatchColors) {
    window.applySwatchColors();
  }
});

window.getOwlStageChildren = function() {
  //owl-stage
  const stage =  document.getElementsByClassName('owl-stage')[1];
  return stage ? Array.from(stage.children) : [];
};

// Step 1 helper for multi-variant image setup: hide all current owl-stage children
window.setupMultipleVariantImagesStep1 = function() {
  const children = window.getOwlStageChildren();
  children.forEach(function(el) {
    if (el && el.style) {
      el.style.display = 'none';
    }
  });
  return children.length;
};

// Step 2 helper: show one active variant image (no parameters)
// Unhides the 5th owl-stage child that step 1 hid and returns its img src/srcset
window.showActiveVariantImage = function() {
  const children = window.getOwlStageChildren();
  if (!children || !children.length) {
    return null;
  }

  // 5th child (index 4) as in your example
  const index = 4;
  const item = children[index];
  if (!item) {
    return null;
  }

  if (item.style) {
    item.style.display = '';
  }

  const img = item.querySelector('img');
  if (!img) {
    return null;
  }

  return {
    src: img.getAttribute('src') || '',
    srcset: img.getAttribute('srcset') || ''
  };
};

// Step 2 (hard-coded version): show variant images whose img src contains 'white'
// Usage from console (after step 1):
//   showVariantImagesBySrc()
// Returns array of { src, srcset } for all matched images
window.showVariantImagesBySrc = function() {
  const substr = 'white';

  const children = window.getOwlStageChildren();
  if (!children || !children.length) {
    return [];
  }

  const matches = [];

  children.forEach(function(item) {
    const img = item && item.querySelector ? item.querySelector('img') : null;
    if (!img) return;

    const src = img.getAttribute('src') || '';
    if (src.includes(substr)) {
      if (item.style) {
        item.style.display = '';
      }
      matches.push({
        src: src,
        srcset: img.getAttribute('srcset') || ''
      });
    }
  });

  if (!matches.length) {
    // No images matched
  }

  return matches;
};

// Helper: show all variant images again (reverse step 1 for every child)
window.showAllVariantImages = function() {
  const children = window.getOwlStageChildren();
  children.forEach(function(el) {
    if (el && el.style) {
      el.style.display = '';
    }
  });
  return children.length;
};

// Test helper: run step 1 and step 2 (white images) in one call
// Usage from console:
//   testWhiteVariantImages()
// Effect:
//   - Hides all owl-stage children
//   - Shows all images whose src contains 'white'
//   - Returns the array from showVariantImagesBySrc()
window.testWhiteVariantImages = function() {
  setupMultipleVariantImagesStep1();
  return showVariantImagesBySrc();
};

window.getActiveVariantImages = function() {
  const el = document.querySelector('variant-selects, variant-radios');
  const v = el && el.currentVariant ? el.currentVariant : null;
  const token = v && v.options ? String(v.options[0] || '').toLowerCase() : (v && v.option1 ? String(v.option1).toLowerCase() : '');
  const lists = [];
  const main = document.getElementById('main-media-container');
  if (main) lists.push(Array.from(main.children));
  const stage = document.querySelector('.product__media-list .owl-stage');
  if (stage) lists.push(Array.from(stage.children));
  const matches = [];
  for (var i = 0; i < lists.length; i++) {
    const children = lists[i];
    for (var j = 0; j < children.length; j++) {
      const item = children[j];
      const img = item.querySelector('img');
      const src = (img && img.getAttribute('src')) || '';
      const dsrc = (img && img.getAttribute('data-src')) || '';
      const set = (img && img.getAttribute('srcset')) || '';
      const dset = (img && img.getAttribute('data-srcset')) || '';
      const all = (src + ' ' + dsrc + ' ' + set + ' ' + dset).toLowerCase();
      if (token && all.indexOf(token) > -1) {
        matches.push({ src: src, srcset: set, element: item });
      }
    }
  }
  return matches;
};

window.getVariantMediaReport = function() {
  const v = window.getCurrentVariant();
  // Extract all variant options for matching (case-insensitive)
  const options = [
    v.option1?.toLowerCase() || '',
    v.option2?.toLowerCase() || '', 
    v.option3?.toLowerCase() || ''
  ].filter(Boolean);
  
  const parents = [];
  const main = document.getElementById('main-media-container');
  if (main) parents.push({ name: 'main', parent: main });
  const stage = document.querySelector('.product__media-list .owl-stage');
  if (stage) parents.push({ name: 'stage', parent: stage });
  const rows = [];
  
  for (var p = 0; p < parents.length; p++) {
    const children = Array.from(parents[p].parent.children);
    for (var i = 0; i < children.length; i++) {
      const item = children[i];
      const img = item.querySelector('img');
      const src = (img && img.getAttribute('src')) || '';
      const dsrc = (img && img.getAttribute('data-src')) || '';
      const set = (img && img.getAttribute('srcset')) || '';
      const dset = (img && img.getAttribute('data-srcset')) || '';
      const all = (src + ' ' + dsrc + ' ' + set + ' ' + dset).toLowerCase();
      
      // Check if ANY variant option matches the image
      let matched = false;
      for (let j = 0; j < options.length; j++) {
        const token = options[j];
        if (!token) continue;
        
        // Try multiple matching strategies for this option
        const tokenWithUnderscores = token.replace(/\s+/g, '_');
        const tokenNoSpaces = token.replace(/\s+/g, '');
        const normalizedToken = token.replace(/\s+/g, '_').toUpperCase();
        const normalizedAll = all.replace(/\s+/g, '_').toUpperCase();
        
        if ((token && all.indexOf(token) > -1) || 
            (tokenNoSpaces && all.indexOf(tokenNoSpaces) > -1) ||
            (tokenWithUnderscores && all.indexOf(tokenWithUnderscores) > -1) ||
            (normalizedToken && normalizedAll.indexOf(normalizedToken) > -1)) {
          matched = true;
          break;
        }
      }
      
      rows.push({ list: parents[p].name, index: i, token: options.join(' / '), matched: matched, src: src, element: item });
    }
  }
  return rows;
};

window.applyVariantMediaFilter = function() {
  const rows = window.getVariantMediaReport();
  const matched = rows.filter(function(r){return r.matched;});
  
  if (rows.length && matched.length === 0) {
    
    return rows;
  }
  
  // Sort the carousel: move matched items to front and sort by src
  if (matched.length > 0) {
    const stage = document.querySelector('.product__media-list .owl-stage');
    if (stage) {
      // Get all stage items and sort them
      const stageItems = Array.from(stage.children);
      
      // Create a map of src to item for quick lookup
      const itemMap = new Map();
      stageItems.forEach((item, index) => {
        const img = item.querySelector('img');
        const src = (img && img.getAttribute('src')) || '';
        itemMap.set(src, { item, originalIndex: index });
      });
      
      // Sort matched items by src alphabetically
      const sortedMatched = matched.slice().sort((a, b) => {
        const srcA = a.src.toLowerCase();
        const srcB = b.src.toLowerCase();
        return srcA.localeCompare(srcB);
      });
      
      // Separate matched and unmatched items
      const matchedItems = [];
      const unmatchedItems = [];
      
      sortedMatched.forEach(matchedRow => {
        const itemData = itemMap.get(matchedRow.src);
        if (itemData) {
          matchedItems.push(itemData.item);
        }
      });
      
      // Add unmatched items (maintaining original order)
      stageItems.forEach(item => {
        const img = item.querySelector('img');
        const src = (img && img.getAttribute('src')) || '';
        const isMatched = matched.some(m => m.src === src);
        if (!isMatched) {
          unmatchedItems.push(item);
        }
      });
      
      // Reorder the DOM: matched items first, then unmatched
      const reorderedItems = [...matchedItems, ...unmatchedItems];
      reorderedItems.forEach(item => stage.appendChild(item));
      
      // Debug - reordered carousel: { 
      //   matchedCount: matchedItems.length, 
      //   unmatchedCount: unmatchedItems.length,
      //   totalCount: reorderedItems.length 
      // });
    }
    
    const owlCarousel = $('.product__media-list').data('owl.carousel');
    
    // Debug - matched items: matched.map(function(m) { return { index: m.index, src: m.src.substring(m.src.lastIndexOf('/') + 1), list: m.list }; })
    
    // Remove active class from all owl-items
    const allOwlItems = document.querySelectorAll('.product__media-list .owl-item');
    allOwlItems.forEach(function(item) {
      item.classList.remove('active');
    });
    
    // Find the first matched item from the STAGE (not main)
    const stageMatched = matched.filter(function(r){return r.list === 'stage';});
    
    if (stageMatched.length > 0) {
      const firstStageMatched = stageMatched[0];
      const firstMatchedElement = firstStageMatched.element;
      
      // Debug - firstMatchedElement: firstMatchedElement
      // Debug - firstMatchedElement tagName: firstMatchedElement.tagName
      // Debug - firstMatchedElement parent: firstMatchedElement.parentElement
      
      // Try different ways to find the owl-item
      let owlItem = firstMatchedElement.closest('.owl-item');
      if (!owlItem) {
        // Try going up through parents
        let parent = firstMatchedElement.parentElement;
        while (parent && !parent.classList.contains('owl-item')) {
          parent = parent.parentElement;
        }
        owlItem = parent;
      }
      
      // Debug - found owlItem: !!owlItem
      
      if (owlItem) {
        owlItem.classList.add('active');
        // Debug - added active class to owl-item
        
        // Get the correct carousel index for the first matched item
        if (owlCarousel && typeof owlCarousel.to === 'function') {
          // Find the actual position of this owl-item in the carousel
          const stageItems = Array.from(document.querySelectorAll('.product__media-list .owl-stage > .owl-item'));
          const actualIndex = stageItems.indexOf(owlItem);
          
          // Debug - stageItems length: stageItems.length
          // Debug - matched index: firstStageMatched.index, actual carousel index: actualIndex
          // Debug - owlCarousel.to function exists: typeof owlCarousel.to
          
          // Move carousel to the correct position (now should be index 0 since we sorted)
          if (actualIndex >= 0) {
            try {
              owlCarousel.to(actualIndex, 300, true);
              
              // Debug - successfully called owlCarousel.to(actualIndex, ')'
              // filtered: { token: rows[0] ? rows[0].token : '', shown: matched.length, total: rows.length, moved_to: actualIndex, set_active: true }
            } catch (error) {
              // Error calling owlCarousel.to
            }
          } else {
            // Invalid actualIndex
          }
        } else {
          // Owl carousel not available
        }
      } else {
        // Could not find owl-item for stage element
      }
    } else {
      // No stage matched items found
    }
  }
  
  return matched;
};


function setTheCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
    
function getTheCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
    
function eraseTheCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
 
function setupWishlistButtons() {
  if(getTheCookie("wishlist") != null && getTheCookie("wishlist") != '__' && getTheCookie("wishlist") != '') {
      var str = String(getTheCookie("wishlist")).split("__");
      for (var i=0; i<str.length; i++) {
        if (str[i] != '') {
          (document.querySelector('.added-wishbutton-'+str[i]) != null) ? document.querySelector('.added-wishbutton-'+str[i]).style.display = "block" : '';
          (document.querySelector('.default-wishbutton-'+str[i]) != null) ? document.querySelector('.default-wishbutton-'+str[i]).remove() : '';
          (document.querySelector('.loadding-wishbutton-'+str[i]) != null) ? document.querySelector('.loadding-wishbutton-'+str[i]).remove() : '';
        }
      }
  }
}
function applyCollectionGridLayout(gridId, itemClass) {
  var productGrid = document.getElementById("product-grid");
  if(!productGrid) return;
  productGrid.querySelectorAll('li').forEach((element) => {
    element.className = itemClass;
  });

  // Move quick buttons into the image overlay position for grid layouts
  productGrid.querySelectorAll('li .card-information__wrapper .thumbnail-buttons').forEach((element) => {
    var node = element;
    var cardInner = element.closest('li') ? element.closest('li').querySelector('.card__inner') : null;
    node.parentElement.removeChild(node);
    if(cardInner) cardInner.appendChild(node);
  });

  var containerClass = gridId;
  if(document.querySelector('#shopify-section-Ishi_sidebar')) containerClass += " with-sidebar";
  document.getElementById("ProductGridContainer").className = containerClass;
}

function setGridLayout() {
  if(!document.querySelectorAll("#ProductGridContainer").length)return;

  // The grid-view switcher has been removed from the storefront: always render a fixed 4-column grid
  if(!document.querySelectorAll(".collectiongrid-layout").length) {
    applyCollectionGridLayout("collectiongrid-layout-4", "grid__item col-lg-3 col-md-6 col-sm-6 col-xs-6");
    return;
  }

  var gridCookie = getTheCookie('collectiongrid-layout');
  if(document.querySelectorAll("[data-id='" + gridCookie + "']").length) {
    document.querySelectorAll(".collectiongrid-layout").forEach((element) => {
    	element.classList.remove("active");
    });
  } else {
    gridCookie = document.querySelector(".collectiongrid-layout.grid-layout-default").getAttribute("data-id");
    setTheCookie("collectiongrid-layout", gridCookie, 14);
  }  
  var classNames = document.querySelector("[data-id='" + gridCookie + "']").classList;
  document.querySelector("[data-id=" + gridCookie + "]").classList =  classNames + " active";
  document.getElementById("product-grid").querySelectorAll('li').forEach((element) => {
    element.className = document.querySelector("[data-id=" + gridCookie + "]").getAttribute("data-class");
  });

  //list-view has the buttons and grid-view has been selected
  if((gridCookie == "collectiongrid-layout-2" || gridCookie == "collectiongrid-layout-3" || gridCookie == "collectiongrid-layout-4") && document.getElementById("product-grid").querySelectorAll('li .card-information__wrapper .thumbnail-buttons').length) {
    document.getElementById("product-grid").querySelectorAll('li').forEach((element) => {
      var node = element.querySelector(".thumbnail-buttons");
      node.parentElement.removeChild(node);
      element.querySelector(".card__inner").append(node);
  	});
  }

  //grid-view has the buttons and listview has been selected
  if((gridCookie == "collectiongrid-layout-1") && document.getElementById("product-grid").querySelectorAll('li .card__inner .thumbnail-buttons').length) {
  	document.getElementById("product-grid").querySelectorAll('li').forEach((element) => {
      var node = element.querySelector(".thumbnail-buttons");
      node.parentElement.removeChild(node);
      element.querySelector(".card-information__wrapper").append(node);
  	});
  }
  document.querySelector('#shopify-section-Ishi_sidebar')? gridCookie += " with-sidebar" : '';
  document.getElementById("ProductGridContainer").className = gridCookie;
}

window.MCCollectionInfiniteScroll = {
  totalPages: 1,
  totalItems: 0,
  nextPage: 2,
  loading: false,
  observer: null,
  scrollHandler: null,
  sentinel: null,

  init: function() {
    var grid = document.getElementById('product-grid');
    var container = document.getElementById('ProductGridContainer');
    if (!grid || !container) return;
    var sentinel = container.querySelector('.mc-collection-load-more');
    if (!sentinel) return;

    this.totalPages = parseInt(grid.getAttribute('data-total-pages'), 10) || 1;
    this.totalItems = parseInt(grid.getAttribute('data-total-items'), 10) || 0;
    this.nextPage = 2;
    this.loading = false;
    this.sentinel = sentinel;
    this.stop();

    var self = this;
    this.checkHandler = function() { self.checkAndLoad(); };
    window.addEventListener('scroll', this.checkHandler, { passive: true });
    window.addEventListener('resize', this.checkHandler);

    // Kick off loading right away when the first batch doesn't fill the screen yet
    setTimeout(function() { self.checkAndLoad(); }, 300);
  },

  stop: function() {
    if (this.checkHandler) {
      window.removeEventListener('scroll', this.checkHandler);
      window.removeEventListener('resize', this.checkHandler);
      this.checkHandler = null;
    }
    this.loading = false;
  },

  checkAndLoad: function() {
    if (this.loading) return;
    if (this.nextPage > this.totalPages) { this.stop(); return; }
    var sentinel = this.sentinel;
    if (!sentinel || !sentinel.parentNode) { this.stop(); return; }
    var rect = sentinel.getBoundingClientRect();
    // Trigger whenever the load marker gets close to (or below) the bottom of the viewport
    if (rect.top <= window.innerHeight + 600) this.loadNextPage();
  },

  loadNextPage: function() {
    var self = this;
    if (this.loading) return;
    if (this.nextPage > this.totalPages) { this.stop(); return; }

    var grid = document.getElementById('product-grid');
    if (grid && this.totalItems > 0 && grid.querySelectorAll('li').length >= this.totalItems) {
      this.stop();
      return;
    }

    this.loading = true;
    var sentinel = this.sentinel;
    if (sentinel) sentinel.classList.add('is-loading');

    var url = window.location.pathname;
    var search = window.location.search ? window.location.search.slice(1) : '';
    var parts = search ? search.split('&') : [];
    var kept = [];
    for (var i = 0; i < parts.length; i++) {
      if (parts[i] && parts[i].indexOf('page=') !== 0) kept.push(parts[i]);
    }
    kept.push('page=' + this.nextPage);
    url += '?' + kept.join('&');

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(response) { return response.text(); })
      .then(function(html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = parsed.getElementById('product-grid');
        var currentGrid = document.getElementById('product-grid');
        if (newGrid && currentGrid) {
          var items = newGrid.querySelectorAll('li');
          var added = false;
          Array.prototype.forEach.call(items, function(item) {
            currentGrid.appendChild(item);
            added = true;
          });
          if (!added) { self.stop(); }
        } else {
          self.stop();
        }
        self.nextPage += 1;
        self.loading = false;
        if (sentinel) sentinel.classList.remove('is-loading');
        if (window.setGridLayout) window.setGridLayout();
        if (window.setupWishlistButtons) window.setupWishlistButtons();
        // If the marker is still within the trigger zone after appending, keep loading
        self.checkAndLoad();
      })
      .catch(function() {
        self.loading = false;
        if (sentinel) sentinel.classList.remove('is-loading');
        self.stop();
      });
  }
};

window.addEventListener('DOMContentLoaded', function() {
  if (window.MCCollectionInfiniteScroll && document.getElementById('ProductGridContainer')) {
    window.MCCollectionInfiniteScroll.init();
  }
});

function addToCartJS(qty,variantID, btn) {   
		    var xhr = new XMLHttpRequest();
		    var url = "/cart/add.js";
		    xhr.open("POST", url, true);
		    xhr.setRequestHeader("Content-Type", "application/json");
		    xhr.onreadystatechange = function () {
		      if (xhr.readyState === 4 && xhr.status === 200) {
		          var parsedState = JSON.parse(xhr.responseText);
		          if(document.querySelector(".ajax-cart-disabled")) window.location = "/cart";
		          document.querySelector('cart-notification').renderContents(parsedState);
				  btn.classList.remove("loading");
		          openCartDrawer();
		      }
		    };
		    var sectionsToRender = ["cart-notification-product", "cart-notification-button", "cart-icon-bubble"];
		    var sections_url = window.location.pathname;
		    var data = JSON.stringify({"quantity": qty, "id": variantID, "sections" : sectionsToRender, "sections_url" : sections_url });
		    xhr.send(data);
		}

function removeFromCartJS(variantID) {
		    var xhr = new XMLHttpRequest();
		    var url = "/cart/change.js";
		    xhr.open("POST", url, true);
		    xhr.setRequestHeader("Content-Type", "application/json");
		    xhr.onreadystatechange = function () {
		      if (xhr.readyState === 4 && xhr.status === 200) {
		          var parsedState = JSON.parse(xhr.responseText);
		          if(document.querySelector(".ajax-cart-disabled")) window.location = "/cart";
		          document.querySelector('cart-notification').renderContents(parsedState);
		      }
		    };
		    var sectionsToRender = ["cart-notification-product", "cart-notification-button", "cart-icon-bubble"];
		    var sections_url = window.location.pathname;
		    var data = JSON.stringify({"quantity": 0, "id": variantID, "sections" : sectionsToRender, "sections_url" :sections_url });
		    xhr.send(data);
		}

		function updateCartItemJS(qty, variantID) {
		    var xhr = new XMLHttpRequest();
		    var url = "/cart/change.js";
		    xhr.open("POST", url, true);
		    xhr.setRequestHeader("Content-Type", "application/json");
		    xhr.onreadystatechange = function () {
		      if (xhr.readyState === 4 && xhr.status === 200) {
		          var parsedState = JSON.parse(xhr.responseText);
		          if(document.querySelector(".ajax-cart-disabled")) window.location = "/cart";
		          document.querySelector('cart-notification').renderContents(parsedState);
		      }
		    };
		    var sectionsToRender = ["cart-notification-product", "cart-notification-button", "cart-icon-bubble"];
		    var sections_url = window.location.pathname;
		    var data = JSON.stringify({"quantity": qty, "id": variantID, "sections" : sectionsToRender, "sections_url" :sections_url });
		    xhr.send(data);
		}

function convertToMoney(price) {
  var price = parseFloat(price / 100).toFixed(2);
  var currency = document.getElementsByTagName("html")[0].getAttribute("currency");
  return currency + price; 
}

function setCountDownTimer(date,target) {
  var t = date.split(/[- :]/);
  var d = new Date(t[0], t[1]-1, t[2], t[3], t[4], t[5]);
  var countDownDate = new Date(d);
  setInterval(function() {
    var now = new Date().getTime();
    var distance = countDownDate - now;
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    // Display the result in the element with id="demo"
   // target.getElementsByClassName("countdown-days")[0].innerHTML = date;
    target.getElementsByClassName("countdown-days")[0].innerHTML = days < 10 ? "0" + days : days;
    target.getElementsByClassName("countdown-hours")[0].innerHTML = hours < 10 ? "0" + hours : hours;
    target.getElementsByClassName("countdown-minutes")[0].innerHTML = minutes < 10 ? "0" + minutes : minutes;
    target.getElementsByClassName("countdown-seconds")[0].innerHTML = seconds < 10 ? "0" + seconds : seconds;
  }, 1000);
}
function openCartDrawer() {   
		    document.querySelector('.cart-notification').classList.add("active");
		    document.querySelector('.cart-overlay').classList.add("active");
		    document.body.classList.add('cart-overflow');
		}

		function closeCartDrawer() {   
		    document.querySelector('.cart-notification').classList.remove("active");
		    document.querySelector('.cart-overlay').classList.remove("active");
		    document.body.classList.remove('cart-overflow');
		}
